import { getCategoryById } from "@/services/pricing-config.service";
import { useQuery } from "@tanstack/react-query";

export const useCategoryById = (categoryId, enabled = true, options = {}) => {
  return useQuery({
    queryKey: ["category", categoryId],
    queryFn: () => getCategoryById({ categoryId }),
    enabled: enabled && !!categoryId,
    ...options,
  });
};
